<template functional>
	<li class="user-dropdown-item" @click="listeners.click">
		<font-awesome-icon :icon="props.icon" v-if="props.icon !== null" class="user-dropdown-icon" fixed-width />
		<slot></slot>
	</li>
</template>

<script>
export default {
	props: {
		icon: { default: null }
	}
};
</script>

<style lang="scss">
@import '../../variables';

.user-dropdown-item {
	color: $app-topbar-menu-color;
	padding: 0 10px;
	line-height: $app-topbar-menu-height;

	.user-dropdown-icon {
		margin-right: 5px;
	}

	&:hover {
		background-color: $app-topbar-menu-bg-hover;
	}
}
</style>
